export const PUBLIC_ROUTES = {
  LOGIN: 'login',
  NOT_FOUND: 'not-found'
}

export const PRIVATE_ROUTES = {
  PRIVATE: 'slenv',
  DASHBOARD: 'dashboard',
  USER_SERVICES: 'user-services',
  OPERAIONS_MONITORING: 'operations-monitoring',
  OPERATING_EXPENSES: 'operating_expenses',
  ACCOUNTING_REPORT: 'accounting-report',
  PRODUCT_PRICES: 'product_prices',
  SALES_BY_SELLER: 'sales_by_seller',
  PURCHASES_REPORT: 'purchases_report',
  VALUED_INVENTORY_REPORT: 'valued_inventory_report',
  PROFIT_REPORT: 'profit_report',
  USERS: 'users',
  TREASURY_MOVEMENT_TYPES: 'treasury-movement-types',
  VOUCHERS: 'vouchers',
  PEOPLE: 'people',
  EMPLOYEES: 'employees',
  MANAGEMENT_DRIVER: 'management_driver',
  STATIONS: 'stations',
  VEHICLES: 'vehicles',
  STORES: 'stores',
  PRODUCT_REQUESTS: 'product_requests',
  INVENTORY: 'inventory',
  PRODUCTS: 'products',
  PURCHASES: 'purchases',
  DISPATCHES: 'dispatches',
  ENTRIES: 'entries',
  OUTPUTS: 'outputs',
  SHIPPING_GUIDES: 'shipping-guides',
  TRANSFERS: 'transfers',
  SERIES_ENTRY: 'series-entry',
  KARDEX: 'kardex',
  CPE: 'cpe',
  TREASURY: 'treasury',
  TREASURY_MOVEMENTS: 'treasury-movements',
  MANAGE_CASH: 'manage_cash',
  CASH_REGISTER: 'cash-register',
  CASH_REGISTER_MOVEMENTS: 'cash-register-movements',
  SALE_RETAINERS: 'sale-retainers',
  CASH_RECEIPTS: 'cash_receipts',
  CASH_OUTLAYS: 'cash_outlays',
  CUSTOMER_CREDITS: 'customer_credits',
  PROVIDER_CREDITS: 'provider_credits',
  SALES: 'sales',
  ORDERS: 'orders',
  PROFORMAS: 'proformas',
  CREDIT_NOTES: 'credit_notes',
  DEBIT_NOTES: 'debit_notes',
  ACCESS_CONTROL: 'access_control',
  MENU_CONTROL: 'menu_control',
  ESTABLISHMENT: 'establishment',

  ATTENTION_SERVICE_ORDERS: 'attention_service_orders',
  VEHICLE_REQUIREMENTS: 'vehicle_requirements',
  VEHICLE_ORDER_SERVICES: 'vehicle_order_services',

  LOANS: 'loans',
  LOANS_OPENING: 'loans_opening',
  LOAN_OPENING_EXPENSES: 'loan_opening_expenses',
  LOAN_OPENING_INCOMES: 'loan_opening_incomes',
  LOANS_REPORT: 'loans_report',

  REPORTS: 'reports',
  REPORTS_TOP_10_CLIENTS: 'reports-top-10-clients',
  REPORTS_PRODUCTS_BY_BRAND: 'reports-products-by-brand',
}

/**
 * @param {object} menus 
 * @return {array}
 */
export const getUserRoutes = (menus) => {
  // Rutas que siempre estarán disponibles para todos los usuarios
  const alwaysAccessibleRoutes = [
    `/${PRIVATE_ROUTES.PRIVATE}`,
    `/${PRIVATE_ROUTES.PRIVATE}/reports`,
  ]

  // Obtener las rutas basadas en los menús del usuario
  const userRoutes = (menus || [])
    .flatMap(menu =>
      (menu.sub_menus || [])
        .map(sub_menu => `/${PRIVATE_ROUTES.PRIVATE}/${sub_menu.url}`)
    )

  return [...alwaysAccessibleRoutes, ...userRoutes]
}